<section class="modal-base">
  <header class="cabecalho-modal">
    <div>
      <h2>Base completa</h2>
      <span>{{ totalContatos }} contato(s)</span>
    </div>
    <button type="button" class="botao-fechar" aria-label="Fechar" (click)="fechar()">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="table-container" #tableContainer (scroll)="onScroll()">
    <mat-table [dataSource]="contatosTable" style="min-width: calc(100% - 20px)">

      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef aria-label="Status"></mat-header-cell>
        <mat-cell *matCellDef="let contato" class="celula-status">
          @if (temIntegracao) {
            @let iconeInteg = iconeIntegracaoContato(contato);
            @if (iconeInteg) {
              <img class="icone-status" [class.icone-integ-cinza]="!!iconeInteg.classe"
                  [src]="iconeInteg.valor" [matTooltip]="iconeInteg.tooltip" alt="">
            }
          }
          @let iconeStatus = iconeStatusContato(tipoDisparo, contato);
          @if (iconeStatus) {
            @if (iconeStatus.tipo === 'mat') {
              <mat-icon [class.status-lido]="iconeStatus.classe === 'status-lido'"
                        [class.status-erro]="iconeStatus.classe === 'status-erro'"
                        [matTooltip]="iconeStatus.tooltip">{{ iconeStatus.valor }}</mat-icon>
            } @else {
              <img class="icone-status" [src]="iconeStatus.valor" [matTooltip]="iconeStatus.tooltip" alt="">
            }
          }
          @if (quantidadeSmsContato(contato) > 1) {
            <img class="icone-custo-dobrado-sms"
              src="assets/icones/icone-custo-dobrado-sms.svg"
              [matTooltip]="mensagemCustoSms(contato)"
              alt="Custo multiplicado">
          }
          @if (exibeAtalhoChat(contato)) {
            <img class="icone-status icone-atalho-chat"
              src="assets/icones/redesign/modulos/chat/components-message/go-to-chat-primary.svg"
              matTooltip="Abrir conversa do contato"
              alt="Abrir conversa do contato"
              role="button"
              tabindex="0"
              (click)="abrirChatContato(contato)"
              (keydown.enter)="abrirChatContato(contato)">
          }
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="nome">
        <mat-header-cell *matHeaderCellDef>Nome</mat-header-cell>
        <mat-cell *matCellDef="let contato">
          <span class="tamanho-max-column ellipse" [matTooltip]="nomeContato(contato)">{{ nomeContato(contato) }}</span>
          @if (!(contato.nomeContato ?? contato.nome)?.trim()) {
            <img class="icone-aviso" src="assets/icones/exclamacao.svg" matTooltip="Nome inválido" alt="Nome inválido">
          }
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="cpf">
        <mat-header-cell *matHeaderCellDef>CPF/CNPJ</mat-header-cell>
        <mat-cell *matCellDef="let contato">
          <span class="ellipse tamanho-max-column" [matTooltip]="contato.cpf | cpfCnpjMask">
            {{ contato.cpf ? (contato.cpf | cpfCnpjMask) : '--' }}
          </span>
          @if (contato.isCpfValido === false) {
            <img class="icone-aviso" src="assets/icones/exclamacao.svg" matTooltip="Documento inválido" alt="Documento inválido">
          }
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="telefone">
        <mat-header-cell *matHeaderCellDef>Número p/ envio</mat-header-cell>
        <mat-cell *matCellDef="let contato">
          <span class="ellipse tamanho-max-column" [matTooltip]="contato.telefone | celularMask">
            {{ contato.telefone ? (contato.telefone | celularMask) : '--' }}
          </span>
          @if (contato.isContatoValido === false) {
            <img class="icone-aviso" src="assets/icones/exclamacao.svg" matTooltip="Número inválido" alt="Número inválido">
          }
          @if (contato.isContatoRepetido) {
            <img class="icone-aviso" src="assets/icones/advertencia.svg" matTooltip="Número repetido" alt="Número repetido">
          }
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="email">
        <mat-header-cell *matHeaderCellDef>E-mail</mat-header-cell>
        <mat-cell *matCellDef="let contato">
          <span class="ellipse tamanho-max-column" [matTooltip]="contato.email">{{ contato.email ?? '--' }}</span>
          @if (contato.isEmailValido === false) {
            <img class="icone-aviso" src="assets/icones/exclamacao.svg" matTooltip="E-mail inválido" alt="E-mail inválido">
          }
        </mat-cell>
      </ng-container>

      @for (coluna of colunasComplementares; track coluna.id) {
        <ng-container [matColumnDef]="coluna.id">
          <mat-header-cell *matHeaderCellDef>{{ coluna.nome | titlecase }}</mat-header-cell>
          <mat-cell *matCellDef="let contato">
            <span class="ellipse tamanho-max-column" [matTooltip]="buscarCampoComplementar(contato, coluna.nome)">
              {{ buscarCampoComplementar(contato, coluna.nome) }}
            </span>
          </mat-cell>
        </ng-container>
      }
      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>

    @if (isCarregando) {
      <div class="carregando">
        <mat-progress-spinner mode="indeterminate" diameter="32"/>
      </div>
    }
    @if (!isCarregando && contatos.length === 0) {
      <div class="estado-vazio">Nenhum contato encontrado.</div>
    }
  </div>
</section>
